import request from '@/config/axios'

export interface ShareholderLevelVO {
  id?: number
  name: string
  bonusRate: number
  upgradeValue?: number
  levelSort: number
  isDefault: boolean
}

export interface ShareholderLevelSimpleVO {
  id: number
  name: string
}

export const getShareholderLevelList = async () => {
  return await request.get<ShareholderLevelVO[]>({ url: '/trade/shareholder/level/list' })
}

export const getShareholderLevelSimpleList = async () => {
  return await request.get<ShareholderLevelSimpleVO[]>({
    url: '/trade/shareholder/level/list-all-simple'
  })
}

export const getShareholderLevel = async (id: number) => {
  return await request.get({ url: '/trade/shareholder/level/get', params: { id } })
}

export const createShareholderLevel = async (data: ShareholderLevelVO) => {
  return await request.post({ url: '/trade/shareholder/level/create', data })
}

export const updateShareholderLevel = async (data: ShareholderLevelVO) => {
  return await request.put({ url: '/trade/shareholder/level/update', data })
}

export const deleteShareholderLevel = async (id: number) => {
  return await request.delete({ url: '/trade/shareholder/level/delete', params: { id } })
}

export const setDefaultShareholderLevel = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/level/set-default', params: { id } })
}
